import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SessionService } from '@edl-development/edl-common';
import { Transition } from '@uirouter/core';
import { EdlTooltipIcon } from 'src/app/components/common-components/enum/edl-tooltip-icon.enum';
import { InitializeEditModePolicy } from 'src/app/components/observation-comments/enums/initialize-edit-mode-policy.enum';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';
import { Domain } from 'src/app/model/enum/observations/domain.enum';
import { NTPEObservationStatus } from 'src/app/model/enum/observations/ntpe/ntpe-observation-status.enum';
import { Subdomain } from 'src/app/model/enum/observations/subdomain.enum';
import { DomainLookup } from 'src/app/model/interfaces/DomainLookup.interface';
import { DomainNavigationData } from 'src/app/model/interfaces/DomainNavigationData.interface';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';
import { NtpeModel } from 'src/app/model/observation/ntpe/ntpe.model';
import { ObservationSectionPermissionsDTO } from 'src/app/model/observation/observation-section-permissions-dto.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { NTPE_GETTING_STARTED_LINK } from 'src/app/properties/observations/ntpe/ntpe.constants';
import { DEFAULT_RUBRIC_LANGUAGE_LINK } from 'src/app/properties/observations/rubric/rubric.constants';
import { ResourceData } from 'src/app/services/resource/resource.service';

@Component({
    selector: 'app-ntp-section-five-rubric',
    templateUrl: './section-five-rubric.component.html',
    styleUrls: ['./section-five-rubric.component.scss']
})
export class SectionFiveRubricComponent implements OnInit {
    @Input() readOnly: boolean = true;
    @Input() resourceFile: ResourceData = {};
    @Input() permissions?: ObservationSectionPermissionsDTO;
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() observationDetails?: NtpeModel;
    @Input() form!: FormGroup;
    @Input() focusAreas: string[] = [];

    @Input() domains: DomainLookup[] = [];
    @Input() showTargetUser: boolean = false;
    @Input() filterType?: DomainFilterType = DomainFilterType.FOCUS_AREAS;
    @Input() domainNavigationData: DomainNavigationData = {};
    @Input() currentRubricComponent?: Subdomain = Subdomain.CONTENT_KNOWLEDGE;

    @Output() navigate = new EventEmitter<number>();
    @Output() save = new EventEmitter<any>();
    @Output() update = new EventEmitter();
    @Output() submit = new EventEmitter();

    public observationType?: ObservationTypeValues.NTPE;
    ObservationTypeValues = ObservationTypeValues;
    public isTargetUser: boolean = false;
    public isEvalUser: boolean = false;

    public rubricLanguageLink: string = DEFAULT_RUBRIC_LANGUAGE_LINK;
    public gettingStartedLink: string = NTPE_GETTING_STARTED_LINK;

    InitializeEditModePolicy = InitializeEditModePolicy;
    EdlTooltipIcon = EdlTooltipIcon;

    showEvaluatorRating: boolean = false;

    constructor(
        private sessionService: SessionService
    ) { }

    ngOnInit(): void {
        this.rubricLanguageLink = this.resourceFile['RubricPDF.Text'] ?? DEFAULT_RUBRIC_LANGUAGE_LINK;

        const currentUser = this.sessionService.user;

        this.isTargetUser = this.observationDetails?.targetUserId === currentUser?.UserID;
        this.isEvalUser = this.observationDetails?.evaluatingUserId === currentUser?.UserID;

        this.showEvaluatorRating = this.isEvalUser || (this.observationDetails?.status ?? -1) > NTPEObservationStatus.PendingRating;
    }

    //#region Permissions
    canComment = () => this.observationDetails?.permissions?.rubric.canComment === true
        || this.observationDetails?.permissions?.midYearUpdate.canComment === true;
    canSave = () => this.observationDetails?.permissions?.midYearUpdate.canSave === true
        || this.observationDetails?.permissions?.rubric.canSave === true
    canSubmitUpdate = () => this.observationDetails?.permissions?.midYearUpdate.canSubmit === true;
    canSubmitRating = () => this.observationDetails?.permissions?.rubric.canSubmit === true;
    canNotifyOfComment(): boolean {
        return ((
            this.observationDetails?.permissions?.rubric.canNudge === true
            || this.observationDetails?.permissions?.midYearUpdate.canNudge === true
        )
            && (this.isTargetUser && (this.observationDetails?.status ?? -1) >= NTPEObservationStatus.PendingRating)
            || (!this.isTargetUser && (this.observationDetails?.status ?? -1) != NTPEObservationStatus.Authenticated))
            ?? false

    }
    //#endregion

    //#region Event Handlers
    onSave = () => this.save.emit();
    onUpdate = () => this.update.emit();
    onSubmit = () => {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        this.submit.emit();
    };
    //#endregion

    public getFormDomains(): FormGroup {
        return <FormGroup>this.form.get('formDomains');
    }

    public getRubricComponentGroup(domain: Domain, component: Subdomain): FormGroup {
        return <FormGroup>this.getFormDomains().get([domain, component]);
    }

    public isFocusArea(subdomain: SubdomainLookup) {
        return this.focusAreas?.includes(subdomain.Key);
    }

}
